import { render } from "./tls.vue?vue&type=template&id=226c5a35"
import script from "./tls.vue?vue&type=script&lang=js"
export * from "./tls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__